module.exports = __webpack_public_path__ + "img/surya.e00c485.jpg";